import { CatalogNode } from '@catalog/const/v2';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CatalogData, CatalogState, StateWithCatalog } from '../catalog-state';
import { getFeatureState } from './feature.selector';

export const getCatalogState: MemoizedSelector<StateWithCatalog, StateUtils.LoaderState<CatalogData>> = createSelector(
  getFeatureState,
  (state: CatalogState) => state.catalog,
);

export const getCatalogValue: MemoizedSelector<StateWithCatalog, CatalogData> = createSelector(
  getCatalogState,
  (state: StateUtils.LoaderState<CatalogData>) => StateUtils.loaderValueSelector(state),
);

export const getCatalogLoading: MemoizedSelector<StateWithCatalog, boolean> = createSelector(
  getCatalogState,
  (state: StateUtils.LoaderState<CatalogData>) => StateUtils.loaderLoadingSelector(state),
);

export const getCatalogError: MemoizedSelector<StateWithCatalog, boolean> = createSelector(
  getCatalogState,
  (state: StateUtils.LoaderState<CatalogData>) => StateUtils.loaderErrorSelector(state),
);

export const getCatalogSuccess: MemoizedSelector<StateWithCatalog, boolean> = createSelector(
  getCatalogState,
  (state: StateUtils.LoaderState<CatalogData>) => StateUtils.loaderSuccessSelector(state),
);

export const getCatalogNode: (nodeId: string) => MemoizedSelector<StateWithCatalog, CatalogNode> = (
  nodeId: string,
): MemoizedSelector<StateWithCatalog, CatalogNode> =>
  createSelector(getCatalogValue, (data: CatalogData) => data.nodes?.[nodeId]);
